import { Box, styled, Theme, Typography, useTheme } from "@mui/material";

import type { JSX } from "react";

interface Props {
  onDownload: () => void;
}

const CensusSuccessful = ({ onDownload }: Props): JSX.Element => {
  const theme = useTheme();
  return (
    <Box>
      <StyledBoxImg1>
        <Typography
          variant="h2"
          color={theme.palette.common.white}
          mb={theme.spacing(2)}
        >
          Thank you!
        </Typography>
        <Typography
          variant="h4"
          color={theme.palette.common.white}
          display="flex"
          mt={theme.spacing(1)}
        >
          This census has been successfully processed.
        </Typography>
        <StyledSvg viewBox="0 0 800 30">
          <path d="M 0 0 Q 400 50 800 0" fill="#832a7f" />
        </StyledSvg>
      </StyledBoxImg1>
      <Box justifyContent="center" textAlign="center" mt={theme.spacing(3)}>
        <Typography variant="body">
          Click{" "}
          <Link variant="body" onClick={onDownload}>
            here
          </Link>{" "}
          to download the newly structured census.
        </Typography>
      </Box>
    </Box>
  );
};

const StyledBoxImg1 = styled(Box)(() => ({
  background:
    "radial-gradient(at top left, rgba(13,111,157,1) 15%, rgba(131,42,127,1) 60%)",
  backgroundPosition: "center",
  flexDirection: "column",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
  height: 250,
  position: "relative",
}));

const StyledSvg = styled("svg")(({ theme }) => ({
  width: "100%",
  backgroundColor: theme.palette.common.white,
  position: "absolute",
  bottom: 0,
}));

const Link = styled(Typography)(({ theme }: { theme: Theme }) => ({
  color: theme.palette.brandPrimary.dark,
  fontWeight: 900,
  cursor: "pointer",
  "&:hover": {
    textDecoration: "underline",
  },
}));

export default CensusSuccessful;
